import { render, staticRenderFns } from "./GalleryTab.vue?vue&type=template&id=6b34f043&"
import script from "./GalleryTab.vue?vue&type=script&lang=js&"
export * from "./GalleryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports